var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPaymentMenuSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 4H2.66667C1.194 4 0 5.194 0 6.66667V25.3333C0 26.806 1.194 28 2.66667 28H29.3333C30.806 28 32 26.806 32 25.3333V6.66667C32 5.194 30.806 4 29.3333 4ZM30.6667 25.3333C30.6667 26.0687 30.0687 26.6667 29.3333 26.6667H2.66667C1.93133 26.6667 1.33333 26.0687 1.33333 25.3333V13.3333H30.6667V25.3333ZM30.6667 12H1.33333V9.33333H30.6667V12ZM30.6667 8H1.33333V6.66667C1.33333 5.93133 1.93133 5.33333 2.66667 5.33333H29.3333C30.0687 5.33333 30.6667 5.93133 30.6667 6.66667V8Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 24.6667C8.05733 24.6667 8.75867 24.4247 9.33333 23.988C9.908 24.4247 10.6093 24.6667 11.3333 24.6667C13.1713 24.6667 14.6667 23.1713 14.6667 21.3333C14.6667 19.4953 13.1713 18 11.3333 18C10.6093 18 9.908 18.242 9.33333 18.6787C8.75867 18.242 8.05733 18 7.33333 18C5.49533 18 4 19.4953 4 21.3333C4 23.1713 5.49533 24.6667 7.33333 24.6667ZM7.33333 19.3333C7.90933 19.3333 8.44133 19.5793 8.832 20.0253H9.83533C10.2253 19.5793 10.7573 19.3333 11.3333 19.3333C12.436 19.3333 13.3333 20.2307 13.3333 21.3333C13.3333 22.436 12.436 23.3333 11.3333 23.3333C10.7573 23.3333 10.2253 23.0873 9.83467 22.6413H8.83133C8.44133 23.0873 7.90933 23.3333 7.33333 23.3333C6.23067 23.3333 5.33333 22.436 5.33333 21.3333C5.33333 20.2307 6.23067 19.3333 7.33333 19.3333Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPaymentMenuSelected);
export default __webpack_public_path__ + "static/media/view_payment_menu_selected.7a955d055c35f2b47e2d947ce07bd02d.svg";
export { ForwardRef as ReactComponent };